<div *ngIf="currentCity" class="container-large">
  <div class="section-header">
    <h2 class="section-title">{{this.word[this.language].search}} {{this.word[this.language].venueZav}}
      {{this.word[this.language].by}} {{this.word[this.language].category}}</h2>
  </div>
  <div class="section-body">
    <div class="new-section skeleton-load" *ngIf="!loaded">
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '0px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '0px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '0px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '0px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '0px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '-10px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '-10px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '-10px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '-10px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" animation="progress" [theme]="{
          display: 'block',
          'border-radius': '5px',
          'margin-bottom': '-10px',
          'background-color': '#c8c8c8',
          'height' : '130px'
        }"></ngx-skeleton-loader>
    </div>

    <div class="new-section venue-type" *ngIf="currentCity != 'plovdiv'">
      <a *ngFor="let category of categories" [routerLink]="'/' + language == 'en' ? language + '/' + category?.link_category : category?.link_category" title="{{category?.name}}">
        <!-- <div class="venue-type-box" style="{{categoriesStyles[category?.id]?.color}}"> -->
        <div class="venue-type-box">
          <i class="{{categoriesStyles[category?.id]?.icon}}"></i>
          <span class="venue-type-title">{{category?.name}}</span>
        </div>
      </a>
    </div>
    <div class="new-section venue-type" *ngIf="currentCity == 'plovdiv'">
      <a *ngFor="let category of categories; let i = index" [routerLink]="'/' + language == 'en' ? language + '/' + category?.link_category : category?.link_category" title="{{category?.name}}">
        <div class="venue-type-box">
          <i class="{{categoriesStylesP[category?.id]?.icon}}"></i>
          <span class="venue-type-title">{{category?.name}}</span>
        </div>
      </a>
    </div>
  </div>
</div>
